module.exports = __webpack_public_path__ + "img/Layer_15.2728df4d.png";